import { useState } from 'react';

const terms = [
  { term: 'Bankroll', def: 'Capital total destinado exclusivamente a las apuestas. Debe estar separado de las finanzas personales.' },
  { term: 'Stake', def: 'Cantidad apostada en una selección concreta. Generalmente expresada como porcentaje del bankroll.' },
  { term: 'ROI', def: 'Return on Investment. Porcentaje de beneficio sobre el total apostado. Un ROI del 5% es excelente a largo plazo.' },
  { term: 'Value Bet', def: 'Apuesta donde la probabilidad real del evento es mayor que la probabilidad implícita en la cuota.' },
  { term: 'Overround', def: 'Margen que añade la casa a las cuotas. La suma de probabilidades implícitas supera el 100%.' },
  { term: 'xG', def: 'Expected Goals. Métrica que mide la calidad de las ocasiones de gol basándose en datos históricos.' },
  { term: 'Hándicap Asiático', def: 'Mercado que elimina el empate asignando ventajas/desventajas de goles a cada equipo.' },
  { term: 'Arbitraje', def: 'Cubrir todos los resultados posibles en diferentes casas para garantizar beneficio independientemente del resultado.' },
  { term: 'Lay Bet', def: 'En exchanges como Betfair, apostar contra un resultado (actuar como la casa).' },
  { term: 'Tilt', def: 'Estado emocional negativo que lleva a tomar decisiones impulsivas, generalmente tras una racha de pérdidas.' },
  { term: 'Closing Line Value (CLV)', def: 'Comparar la cuota a la que apostaste con la cuota de cierre. Positivo indica que apostaste con valor.' },
  { term: 'Sharp', def: 'Apostador profesional cuyas apuestas mueven el mercado. Las casas limitan o cierran sus cuentas.' },
  { term: 'Soft Book', def: 'Casa de apuestas con cuotas menos eficientes, más fácil de encontrar valor. Suelen limitar a los ganadores.' },
  { term: 'Exchange', def: 'Plataforma donde los usuarios apuestan entre sí (Betfair, Smarkets). Sin margen de casa, solo comisión.' },
  { term: 'Dutching', def: 'Apostar en múltiples selecciones de un mismo evento para garantizar el mismo beneficio en cualquiera de ellas.' },
  { term: 'Acumulador', def: 'Apuesta combinada de varias selecciones. Las cuotas se multiplican pero todas deben acertar.' },
  { term: 'EV (Expected Value)', def: 'Valor esperado de una apuesta. EV positivo indica apuesta rentable a largo plazo.' },
  { term: 'PPDA', def: 'Passes Allowed Per Defensive Action. Mide la intensidad de la presión alta de un equipo.' },
  { term: 'Regresión a la media', def: 'Tendencia de los resultados extremos a volver hacia el promedio con el tiempo.' },
  { term: 'Línea de apertura', def: 'Cuota inicial publicada por la casa antes de que el mercado la ajuste con el volumen de apuestas.' },
];

export default function GlossarySection() {
  const [search, setSearch] = useState('');
  const filtered = terms.filter(
    (t) =>
      t.term.toLowerCase().includes(search.toLowerCase()) ||
      t.def.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <section id="glosario" className="py-20 bg-[#080a0f]">
      <div className="max-w-[1440px] mx-auto px-6">
        {/* Header */}
        <div className="flex items-start gap-4 mb-10">
          <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#00e87a]/10 border border-[#00e87a]/20 flex-shrink-0">
            <i className="ri-book-open-line text-[#00e87a] text-xl"></i>
          </div>
          <div>
            <p className="text-[#00e87a] text-xs font-semibold uppercase tracking-widest mb-1">Capítulo 5</p>
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-2" style={{ fontFamily: "'Syne', sans-serif" }}>
              Glosario de Términos
            </h2>
            <p className="text-[#a8b2c1] text-base max-w-2xl">
              Todos los términos que necesitas conocer para entender el mundo de las apuestas deportivas.
            </p>
          </div>
        </div>

        {/* Search */}
        <div className="relative max-w-md mb-8">
          <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
            <i className="ri-search-line text-[#6b7280] text-sm"></i>
          </div>
          <input
            type="text"
            placeholder="Buscar término..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full pl-9 pr-4 py-2.5 bg-[#0d0f14] border border-[#1e2028] rounded-lg text-white text-sm placeholder-[#4b5563] focus:outline-none focus:border-[#00e87a]/40 transition-colors"
          />
        </div>

        {/* Terms grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {filtered.map((t) => (
            <div key={t.term} className="flex gap-4 p-4 bg-[#0d0f14] border border-[#1e2028] rounded-xl hover:border-[#2a2d3a] transition-colors">
              <div className="flex-shrink-0 mt-0.5">
                <div className="w-2 h-2 rounded-full bg-[#00e87a] mt-1.5"></div>
              </div>
              <div>
                <span className="text-white font-semibold text-sm">{t.term}</span>
                <p className="text-[#6b7280] text-xs leading-relaxed mt-0.5">{t.def}</p>
              </div>
            </div>
          ))}
          {filtered.length === 0 && (
            <div className="col-span-2 text-center py-10 text-[#4b5563] text-sm">
              No se encontraron términos para &quot;{search}&quot;
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
